<template>
  <div class="Nosotros">
    <div class="banner">
      <img class="img28" src="@/assets/home/img28.png" />
    </div>
    <div class="content">
      <img class="img29" src="@/assets/home/img29.png" />
      <img class="img30" src="@/assets/home/img30.png" />
    </div>
    <div class="desc-box">
      <img class="img31" src="@/assets/home/img31.png" />
      <div class="desc-r">
        <div class="desc-title">
          <span style="color: #1b67c8">Introducción</span>
          <span> a Nuestra Empresa</span>
          <img class="img1" src="@/assets/home/img1.png" />
        </div>
        <div class="desc-desc">
          Zoriona, S.A. de C.V. es una empresa financiera innovadora con sede en
          Nuevo León, México, dedicada a proporcionar soluciones de crédito
          accesibles y eficientes a través de nuestra aplicación de préstamos en
          línea. Nuestra misión es simplificar el proceso de obtención de
          crédito para nuestros clientes, permitiéndoles acceder a fondos
          rápidamente y de manera segura.
        </div>
      </div>
    </div>
    <div class="desc-box">
      <div class="desc-r" style="text-align: left; align-items: flex-start">
        <div class="desc-title">
          <span>Nuestro</span>
          <span style="color: #1b67c8">Enfoque</span>
          <img
            style="left: 0; right: auto"
            class="img1"
            src="@/assets/home/img1.png"
            alt=""
          />
        </div>
        <div class="desc-desc">
          Nos enorgullamos en brindar un servicio de préstamo que sea no sólo
          confiable y seguro, sino también flexible y personalizado para las
          necesidades individuales de nuestros clientes. Nuestra plataforma ha
          sido diseñada para adaptarse a las demandas cambiantes del mercado
          financiero, asegurándonos que podamos ofrecer productos que se ajusten
          a las expectativas modernas de nuestros usuarios.
        </div>
      </div>
      <img class="img31" src="@/assets/home/img32.png" />
    </div>
    <!-- <div class="Contacto">
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        "
      >
        <img class="img34" src="@/assets/home/img33.png" />
        <div>
          <div class="box3-title">Contacto</div>
          <div class="box3-desc wi420">
            Puede comunicarse con nosotros a través de nuestro correo
            electrónico corporativo
            <span style="color: #1b67c8">servicio@zorionasofom.com</span> para
            cualquier inquietud o para obtener más información sobre nuestros
            servicios de crédito. Estamos comprometidos a brindarle el soporte y
            la atención personalizada que merece.
          </div>
        </div>
        <img class="img34" src="@/assets/home/img35.png" />
      </div>
      <div class="box3">
        <div class="box3-item">
          <div class="box3-title">Nuestra Ubicación</div>
          <div class="box3-desc">
            Nos enorgullamos en brindar un servicio de préstamo que sea no sólo
            confiable y seguro, sino también flexible y personalizado para las
            necesidades individuales de nuestros clientes. Nuestra plataforma ha
            sido diseñada para adaptarse a las demandas cambiantes del mercado
            financiero, asegurándonos que podamos ofrecer productos que se
            ajusten a las expectativas modernas de nuestros usuarios.
          </div>
        </div>
        <div class="box3-item">
          <img class="img34" src="@/assets/home/img34.png" />
        </div>
        <div class="box3-item">
          <div class="box3-title">Nuestro Compromiso</div>
          <div class="box3-desc">
            En Zoriona, S.A. de C.V., nos comprometemos a mantener la excelencia
            en nuestros servicios financieros, siempre buscando mejorar y
            expandir nuestro rango de productos para satisfacer las necesidades
            de nuestros clientes. Confíe en nosotros para su próximo préstamo y
            descubra por qué somos una opción líder en el sector financiero
            mexicano.
          </div>
        </div>
      </div>
    </div> -->
    <div class="newbox">
      <div style="display: flex">
        <div class="box3-item">
          <div class="box3-title">Contacto</div>
          <div class="box3-desc wi420">
            Puede comunicarse con nosotros a través de nuestro correo
            electrónico corporativo
            <span style="color: #1b67c8">servicio@zorionasofom.com</span> para
            cualquier inquietud o para obtener más información sobre nuestros
            servicios de crédito. Estamos comprometidos a brindarle el soporte y
            la atención personalizada que merece.
          </div>
        </div>
        <div class="box3-item">
          <img class="img34" src="@/assets/home/img34.png" />
        </div>
      </div>
      <div style="display: flex">
        <div class="box3-item">
          <img class="img34" src="@/assets/home/img35.png" />
        </div>
        <div class="box3-item">
          <div class="box3-title">Nuestro Compromiso</div>
          <div class="box3-desc">
            En Zoriona, S.A. de C.V., nos comprometemos a mantener la excelencia
            en nuestros servicios financieros, siempre buscando mejorar y
            expandir nuestro rango de productos para satisfacer las necesidades
            de nuestros clientes. Confíe en nosotros para su próximo préstamo y
            descubra por qué somos una opción líder en el sector financiero
            mexicano.
          </div>
        </div>
      </div>
    </div>
    <div class="Contacto">
      <div class="url">
        <span class="tishi"
          >Contamos con una licencia financiera en cumplimiento de la normativa
          aplicable:</span
        >
        <span
          style="text-decoration: underline; cursor: pointer"
          @click="topage"
          >https://webapps.condusef.gob.mx/SIPRES/jsp/home_publico.jsp?idins=16394</span
        >
        <img class="img37" src="@/assets/home/img37.png" />
      </div>
    </div>
    <div style="display: flex; justify-content: center">
      <img src="@/assets/home/zhizhi.png" class="zhizhi" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacidad-page',
  components: {},
  data() {
    return {};
  },
  methods: {
    topage() {
      window.open(
        'https://webapps.condusef.gob.mx/SIPRES/jsp/home_publico.jsp?idins=16394'
      );
    },
  },
};
</script>

<style scoped>
.banner {
  height: 474px;
  background: linear-gradient(180deg, #9bbce7 0%, #c5dbf7 42%, #eff6ff 100%);
  position: relative;
  margin-top: -70px;
  box-sizing: border-box;
  margin-bottom: 40px;
}
.img28 {
  width: 100%;
  height: 404px;
  margin-top: 70px;
}
.content {
  padding: 0 360px;
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 120px;
}
.img29 {
  width: 900px;
  height: 671px;
}
.img30 {
  width: 394px;
  height: 394px;
  position: absolute;
  bottom: 0;
  right: 260px;
}
.img31 {
  width: 424px;
  height: 424px;
}
.desc-r {
  width: 654px;
  text-align: right;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
}
.desc-box {
  padding: 0 360px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 110px;
}
.desc-title {
  width: 504px;
  font-weight: bold;
  font-size: 46px;
  position: relative;
  margin-bottom: 45px;
}
.img1 {
  width: 386px;
  height: 44px;
  position: absolute;
  right: 0;
  bottom: -35px;
}
.desc-desc {
  font-size: 24px;
  color: #000000;
  line-height: 36px;
}
.Contacto {
  display: flex;
  padding: 0 360px;
  justify-content: space-between;
  margin-bottom: 130px;
}
.box3 {
  width: 592px;
  height: 1083px;
  /* background-image: url('@/assets/home/img36.png'); */
  /* background-size: 100% 100%; */
  display: flex;
  flex-direction: column;
}
.box3-item {
  flex: 1;
  padding: 47px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.box3-title {
  font-weight: bold;
  font-size: 40px;
  color: #000000;
  margin-bottom: 20px;
}
.img34 {
  width: 222px;
  height: 222px;
  margin: 0 auto;
}
.box3-desc {
  font-size: 20px;
  color: #000000;
  line-height: 26px;
}
.wi420 {
  width: 420px;
}
.url {
  width: 1200px;
  height: 103px;
  /* line-height: 103px; */
  padding: 0 60px;
  background: linear-gradient(270deg, rgba(209, 225, 243, 0) 0%, #a9ccff 100%);
  border-radius: 83px;
  filter: blur(0px);
  font-weight: bold;
  font-size: 20px;
  color: #1b67c8;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.tishi {
  font-size: 16px;
  margin-bottom: 10px;
  color: #000000;
}
.img37 {
  width: 215px;
  height: 215px;
  position: absolute;
  right: 0;
  top: 0;
}
.newbox {
  padding: 0 360px;
  margin-bottom: 40px;
}
.zhizhi {
  width: 1200px;
  height: 551px;
  margin-bottom: 100px;
}
</style>
